import { render, staticRenderFns } from "./Waiver.vue?vue&type=template&id=399414ec"
import script from "./Waiver.vue?vue&type=script&lang=ts"
export * from "./Waiver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports